import React, { FC } from "react"

const CheckIcon: FC = () => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
      <path
        d="M13.3337 4L6.00033 11.3333L2.66699 8"
        stroke="#EEF5FD"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default CheckIcon
